/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleMerchantProductMappingData
 */
export interface GoogleMerchantProductMappingData {
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantProductMappingData
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantProductMappingData
     */
    merchantAccountId?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantProductMappingData
     */
    productIdentityKey?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantProductMappingData
     */
    erpIntegrationId?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantProductMappingData
     */
    erpProductRemoteId?: string;
    /**
     * 
     * @type {GoogleMerchantProductMappingDataMethodEnum}
     * @memberof GoogleMerchantProductMappingData
     */
    method?: GoogleMerchantProductMappingDataMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantProductMappingData
     */
    confirmedByUserId?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantProductMappingData
     */
    confirmedAt?: string;
}


/**
 * @export
 */
export const GoogleMerchantProductMappingDataMethodEnum = {
    ManualConfirmed: 'manual-confirmed',
    ExactRemoteId: 'exact-remote-id',
    UniqueGtin: 'unique-gtin',
    UniqueMpnBrand: 'unique-mpn-brand'
} as const;
export type GoogleMerchantProductMappingDataMethodEnum = typeof GoogleMerchantProductMappingDataMethodEnum[keyof typeof GoogleMerchantProductMappingDataMethodEnum];


/**
 * Check if a given object implements the GoogleMerchantProductMappingData interface.
 */
export function instanceOfGoogleMerchantProductMappingData(value: object): value is GoogleMerchantProductMappingData {
    return true;
}

export function GoogleMerchantProductMappingDataFromJSON(json: any): GoogleMerchantProductMappingData {
    return GoogleMerchantProductMappingDataFromJSONTyped(json, false);
}

export function GoogleMerchantProductMappingDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleMerchantProductMappingData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'merchantAccountId': json['merchantAccountId'] == null ? undefined : json['merchantAccountId'],
        'productIdentityKey': json['productIdentityKey'] == null ? undefined : json['productIdentityKey'],
        'erpIntegrationId': json['erpIntegrationId'] == null ? undefined : json['erpIntegrationId'],
        'erpProductRemoteId': json['erpProductRemoteId'] == null ? undefined : json['erpProductRemoteId'],
        'method': json['method'] == null ? undefined : json['method'],
        'confirmedByUserId': json['confirmedByUserId'] == null ? undefined : json['confirmedByUserId'],
        'confirmedAt': json['confirmedAt'] == null ? undefined : json['confirmedAt'],
    };
}

export function GoogleMerchantProductMappingDataToJSON(json: any): GoogleMerchantProductMappingData {
    return GoogleMerchantProductMappingDataToJSONTyped(json, false);
}

export function GoogleMerchantProductMappingDataToJSONTyped(value?: GoogleMerchantProductMappingData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'merchantAccountId': value['merchantAccountId'],
        'productIdentityKey': value['productIdentityKey'],
        'erpIntegrationId': value['erpIntegrationId'],
        'erpProductRemoteId': value['erpProductRemoteId'],
        'method': value['method'],
        'confirmedByUserId': value['confirmedByUserId'],
        'confirmedAt': value['confirmedAt'],
    };
}

